export class AlertsMoke{
    public static alerts:any=[
     {
        alertid:1,
        alertscount:3,
        alerts:["Alerts Data 1","Alerts Data 2","Alerts Data 3"],
        patientInfo: {
            id: "1",
            firstName: "Janna",
            middleName:"",
            lastName: "Wallbrook",
            gender: "Female",
            dateOfBirth: "11/16/2021",
            deviceID: "KD01RBA0000",
            deviceStatus: "Not Owned"
          },
        medicalInfo: {
        vitals: "SpO2(88%)",
        vitalCheckedTime: "6:09",
        patientVital: "critical",
        medicalCondition: ["Asthma","Thairod"],
        },
     },
     {
        alertid:2,
        alertscount:3,
        alerts:["Alerts Data 1","Alerts Data 2","Alerts Data 3"],
        patientInfo: {
            id: "1",
            firstName: "Janna",
            middleName:"",
            lastName: "Wallbrook",
            gender: "Female",
            dateOfBirth: "11/16/2021",
            deviceID: "KD01RBA0000",
            deviceStatus: "Not Owned"
          },
        medicalInfo: {
        vitals: "SpO2(88%)",
        vitalCheckedTime: "6:09",
        patientVital: "critical",
        medicalCondition: ["Asthma","Thairod"],
        },
     },
     {
        alertid:3,
        alertscount:3,
        alerts:["Alerts Data 1","Alerts Data 2","Alerts Data 3"],
        patientInfo: {
            id: "1",
            firstName: "Janna",
            middleName:"",
            lastName: "Wallbrook",
            gender: "Female",
            dateOfBirth: "11/16/2021",
            deviceID: "KD01RBA0000",
            deviceStatus: "Not Owned"
          },
        medicalInfo: {
        vitals: "SpO2(88%)",
        vitalCheckedTime: "6:09",
        patientVital: "critical",
        medicalCondition: ["Asthma","Thairod"],
        },
     }     
         
    ]
}